import { createAction, createReducer } from '@reduxjs/toolkit'

type State = { hasNotification: boolean }

const initialState = { hasNotification: false }

export function createInitialState(): State {
  return initialState
}

const SET_HAS_NOTIFICATION = 'has-notification/set' as const
const CLEAR_HAS_NOTIFICATION = 'has-notification/clear' as const

export const setHasNotification = createAction<boolean>(SET_HAS_NOTIFICATION)
export const clearHasHasNotification = createAction(CLEAR_HAS_NOTIFICATION)

export const reducer = createReducer(createInitialState(), builder => {
  builder
    .addCase(setHasNotification, (state, action) => {
      state.hasNotification = action.payload
    })
    .addCase(clearHasHasNotification, state => {
      state.hasNotification = initialState.hasNotification
    })
    .addDefaultCase(() => {
      return
    })
})
